module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_TOC_Heading",
    attrs: {
      "id": "tableofcontents"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0002#auto_bookmark_toc_2"
    }
  }, [_vm._v("Blurb")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0003#auto_bookmark_toc_3"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0004#auto_bookmark_toc_4"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_toc_5"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_toc_6"
    }
  }, [_vm._v("Last Call")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0007#auto_bookmark_toc_7"
    }
  }, [_vm._v("In the Cold and Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0008#auto_bookmark_toc_8"
    }
  }, [_vm._v("Strange Awakenings")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0009#auto_bookmark_toc_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boris and Natasha")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0010#auto_bookmark_toc_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neglecting a Civic Duty")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0011#auto_bookmark_toc_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Little Slip")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0012#auto_bookmark_toc_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There’s Something to be Said About Accepting Your Fate")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0013#auto_bookmark_toc_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helplessly Hoping")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0014#auto_bookmark_toc_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Like it Was Normal")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0015#auto_bookmark_toc_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("As the Kitten Grows")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0016#auto_bookmark_toc_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kittens and their Dagger-Like Claws")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0017#auto_bookmark_toc_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Box")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0018#auto_bookmark_toc_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Which Killian Kills Nobody")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0019#auto_bookmark_toc_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Boiling Fury of a Cold Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0020#auto_bookmark_toc_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easter Egg Hunt")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0021#auto_bookmark_toc_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frances’s Best Present—Merry Couplemas 3")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0022#auto_bookmark_toc_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Still in a Holiday Story Mood? Read on for an Excerpt from ChrisMyths by Amy Lane.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0025#auto_bookmark_toc_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0026#auto_bookmark_toc_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By Amy Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0027#auto_bookmark_toc_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More from Amy Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visit Dreamspinner Press")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0029#auto_bookmark_toc_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0